import React,{Fragment} from 'react';
import styled from "styled-components";
import ImpulsaTuMarca from "../svg/ImpulsaTuMarca";
import CoheteSvg from "../svg/Cohete-svg";
import AgenciaMarketing from "./layouts/SeccionAgenciaMarketing";
import MujerEnPcSvg from "../svg/MujerEnPc"
import Servicios from './layouts/Servicios';
import Contacto from '../contacto/Contacto';
import Footer from '../footer/Footer';



const Inicio = () => {
    return (
        <Fragment>

          <DivSvg>
            <ImpulsaTuMarca/> 
            <CoheteSvg/> 
          </DivSvg>

          <H1>Agencia de marketing digital</H1>

          <DivAgencia>
          <AgenciaMarketing/>
          <MujerEnPcSvg/>
          </DivAgencia>

     
          <Servicios/>
        
          <Contacto/>
         
          <Footer/>


        </Fragment>
      );
}
 
export default Inicio;


/**estilos */

const DivSvg = styled.div`
overflow-x: hidden;
display: flex;
width: 100%;
flex-direction: row;
background-color: #ECF8F8 ;
align-items: flex-start;
clip-path: polygon(0 0, 100% 0, 100% 73%, 50% 100%, 48% 100%, 0 73%, 0 35%);


@media (max-width: 568px) {
    flex-direction: column;
  }


`


const DivAgencia = styled.div`

display: flex;



@media (max-width: 668px) {
  flex-direction: column-reverse;
align-items: center;
   justify-content: center; 
  }

`

const H1 = styled.h1`
text-transform: uppercase;
letter-spacing: 0.5em;
text-align: center;
margin: 60px auto;
color: #7B7554;



`


